import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useRouter } from "next/router";
import { useForm } from "react-hook-form";

import Layout from "../../components/layouts/layout.comp";
import { useTranslation } from "../../core/translation.core";
import ManualOrderEditor from "../../components/order/ManualOrderEditor";
import orderCore from "../../core/order.core";
import { ManualOrderFormData } from "../../types/order";

export default function CreateOrderPage() {
  const { t, msg } = useTranslation();
  const methods = useForm<ManualOrderFormData>({
    defaultValues: {
      sfCode: "",
      addr: {},
      shipType: "pickup",
    },
  });
  const { push } = useRouter();
  const queryClient = useQueryClient();

  const mutation = useMutation<void, Error, ManualOrderFormData>({
    mutationFn: async (data: ManualOrderFormData) => {
      await orderCore.adminCreateOrder(data);
    },

    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["orders"] });
      push("/orders");
    },
  });

  return (
    <Layout title={t(msg.order.create)}>
      <ManualOrderEditor methods={methods} mutation={mutation} btnName={t(msg.form.create)} />
    </Layout>
  );
}
